module.exports = __webpack_public_path__ + "img/Guernsey.d37ca192.svg";